import  {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import { StartupService } from '../../core/service/startup.service';
import { ErrorHandlingService } from '../../core/service/error-handling.service';
import { TranslateService } from '@ngx-translate/core';
import {CONSTANTS_VALUE} from '../../config/constants.module';
import {SharedModule} from '../../shared/shared.module';

@Component({
  selector: 'error',
  templateUrl: 'error.component.html',
  styleUrls: ['error.component.scss'],
  standalone: false
})
export class ErrorComponent implements OnInit, AfterViewInit {
  public errors: any;
  APP_TITLE = CONSTANTS_VALUE.appTitle;

  constructor(
    @Inject(StartupService) protected _startupService: StartupService,
    @Inject(ErrorHandlingService) private _errorHandlingService: ErrorHandlingService,
    @Inject(TranslateService) private _translate: TranslateService
  ) {
    // set is started true to hide start panel
    this._startupService.isStarted = true;
    this.errors = new Array();
  }

  ngOnInit() {
    this._startupService.hasFailed = false;
    for (let i = 0; i < this._errorHandlingService.errors.length; i++) {
      const key = this._errorHandlingService.getHttpErrorResponseTranslationKey(this._errorHandlingService.errors[i]);
      // get Translate and register Select2 Elements
      this._translate.get(key).subscribe(errorMessage => {
        this.errors.push(errorMessage);
      });
    }
  }

  ngAfterViewInit(): void {
    this._errorHandlingService.clearInternalErrorStack();
  }
}
